/**
 * @type {object} BBreakpoint
 * @property {jQuery} $targetElement The element whose breakpoint we want to discover.
 */
export default class BBreakpoint {

    constructor($element) {
        this.$targetElement = $element;
    }

    computeLayoutPercentageWidth() {
        let size = BBreakpoint.findSize();

        let classChain = BBreakpoint.extractColumnChain(this.$targetElement);
        let effectiveBreakpoints = classChain.map(BBreakpoint.mapEffectiveBreakpoint.bind(this, size));

        // So that we never end up with a breakpoint of 0.
        let breakpoint = BBreakpoint.computeNestedRowBreakpoint(effectiveBreakpoints);
        return SizeLookup.approximatePercentWidth(size, breakpoint);
    }

    /**
     * Flatten the list of breakpoints we've discovered into a final, effective breakpoint
     * for the element, taking into account nested rows.
     * @param {[Number]} effectiveBreakpoints Array of computed breakpoints of parents.
     */
    static computeNestedRowBreakpoint(effectiveBreakpoints) {
        console.log("Reducing effective breakpoints: " + JSON.stringify(effectiveBreakpoints));
        let computed =  effectiveBreakpoints.reduce(function (final, current) {
            if(!final) {
                return current;
            }

            return BBreakpoint.normalizeBreakpoint(current, final);
        }, null);

        return Math.min(12, Math.ceil(computed));
    }

    /**
     * Normalize the breakpoint by first converting the breakpoint number
     * to a fraction of 12 (the full width of the grid). Then, divide the
     * parent's width by this fraction to compute the nested breakpoint.
     *
     * @param {Number} breakpoint The breakpoint to normalize.
     * @param {Number} parentBreakpointWidth The width of the parent.
     * @return {Number} Normalized breakpoint.
     */
    static normalizeBreakpoint(breakpoint, parentBreakpointWidth) {
        // Compute fraction of 12 that current breakpoint is.
        let fraction = 12 / breakpoint;

        // Compute flattened breakpoint by dividing final by fraction.
        return parentBreakpointWidth / fraction;
    }

    /**
     * Uses current size and list classes to extract the applicable breakpoint.
     * Bootstrap sizes bind upward, so if current size column is not found, the
     * applicable size is the previous one defined. If no previous one, breakpoint
     * is "12".
     * @param {String} size The size to find.
     * @param {[String]} classArray All classes.
     * @return {Number} The determined breakpoint.
     */
    static mapEffectiveBreakpoint(size, classArray) {
        let mapping = new ColumnMapping(classArray);
        return mapping[size];
    }

    /**
     * Get a list of parent element column class lists (each element a list of classes).
     * Lists are ordered from target element classes (as first element) to the classes
     * of the element just below the container.
     * @param {jQuery} $targetElement The element from which to extract the list.
     */
    static extractColumnChain($targetElement) {
        let chain = [];
        do {
            let classStr = $targetElement.attr('class') || '';
            chain.push(classStr.split(' '));
            $targetElement = $targetElement.parent();
        } while(
            $targetElement &&
            !$targetElement.is("body") &&
            !$targetElement.hasClass("container") &&
            !$targetElement.hasClass("container-responsive"));

        return BBreakpoint.filterNonColumns(chain);
    }

    /**
     * Removes all class lists from the chain that don't sit directly below
     * a "row".
     * @param {[String]} rawChain The full list of classes in the chain.
     * @return {Array} Only the applicable columns.
     */
    static filterNonColumns(rawChain) {
        // We can then discard any columns that are not directly below a row.
        let chain = [];
        for(let i = rawChain.length - 1; i > 0; i--) {
            if(rawChain[i].includes("row")) {
                // Found row, grab classes in child element and skip both.
                chain.unshift(rawChain[i - 1]);
                i--;
            }
        }

        return chain;
    }

    static findSize() {
        BBreakpoint.addTestDivs();
        let hiddenElement = BBreakpoint.$TEST_DIVS.find(":hidden").first().attr('id');
        BBreakpoint.removeTestDivs();
        return hiddenElement;
    }

    static addTestDivs() {
        $("body").append(BBreakpoint.$TEST_DIVS);
    }

    static removeTestDivs() {
        BBreakpoint.$TEST_DIVS.detach();
    }

    static createTestDivs() {
        let html = "<div id='test-divs'>" +
            BBreakpoint.createDiv("xs", BBreakpoint.SizeTestDivClasses.XS) +
            BBreakpoint.createDiv("sm", BBreakpoint.SizeTestDivClasses.SM) +
            BBreakpoint.createDiv("md", BBreakpoint.SizeTestDivClasses.MD) +
            BBreakpoint.createDiv("lg", BBreakpoint.SizeTestDivClasses.LG) +
            "</div>";
        return $(html);
    }

    static createDiv(id, className) {
        return "<div id='" + id + "' class='" + className + "'></div>";
    }
}

BBreakpoint.SizeTestDivClasses = {
    XS : "hidden-xs",
    SM : "hidden-sm",
    MD : "hidden-md",
    LG : "hidden-lg"
};

class SizeLookup {


    static approximatePercentWidth(size, breakpoint) {
        console.log("Computing percent width for size: " + size + ", breakpoint: " + breakpoint);

        var fractionalValue = SizeLookup._containerWidth(size) * breakpoint / 12 / window.innerWidth;;
        let retVal = (fractionalValue * 100) + "vw";
        console.log("Computed size: " + retVal);
        return retVal;
    }

    static _containerWidth(size) {
        switch(size) {
            case "sm":
                return SizeLookup.ContainerWidth.SM;
            case "md":
                return SizeLookup.ContainerWidth.MD;
            case "lg":
                return SizeLookup.ContainerWidth.LG;
            default:
                return window.innerWidth;
        }
    }
}
SizeLookup.ContainerWidth = {
    SM : 750,
    MD : 970,
    LG : 1170,
};


class ColumnMapping {

    /**
     * Creates mapping from list of column classes.
     * @param {[String]} classList The list of column classes.
     */
    constructor(classList) {
        classList.forEach(function (className) {
            let result = className.match(ColumnMapping._COL_PATTERN);
            if(result) {
                this[result[1] + "_orig"] = Number(result[2]);
            }
        }.bind(this));
        this.computeEffectiveBreakpoints();
    }

    /**
     * Collapses the originally defined breakpoints into effective
     * breakpoints for every size.
     */
    computeEffectiveBreakpoints() {
        this.xs = this['xs_orig'] || 12;
        this.sm = this['sm_orig'] || this.xs;
        this.md = this['md_orig'] || this.sm;
        this.lg = this['lg_orig'] || this.md;
    }
}
ColumnMapping._COL_PATTERN = /col-(xs|sm|md|lg)-(\d\d?)/;

/**
 * @type {jQuery} $TEST_DIVS The divs to be attached and detached for testing breakpoints.
 */
BBreakpoint.$TEST_DIVS = BBreakpoint.createTestDivs();
